import { SiNoType } from "../siNo/SiNo"

import { UserType } from "../../libs/user/User"
import { FisicaType } from "../people/PeopleSlice"
import { ContractorType } from "../people/contractor/Contractor"

export type AccidentType = { anno: string | undefined, responsabilita: string | undefined, numero: number }
export type AccidentListType = AccidentType[]
export type AccidentErrorType = {numero: number, error: string | undefined}
export type AccidentErrorList = AccidentErrorType[]

export interface BaseAccidentProps {
    incidente: AccidentType
    incidenteError: AccidentErrorType
}

export interface AccidentProps extends BaseAccidentProps { 
    updateIncidente: Function

    tipiAnno: any
    tipiResponsabilita: any
}

/**
 * Stato assicurativo.
 * NOTA: le informazioni sullo stato della polizza (già attiva e data scandenza son già espresse nel "BasePageState")
 */
export type InsuranceDataStatus = {
    statoAssicurativo: string | undefined
    
    // casi --> Nuovo || Usato
    tipoEreditaCu: number | undefined
    tipoVeicoloEreditaCu: number | undefined
    targaCu: string | undefined
    cuEreditata: number | undefined
    // casi <-- Nuovo || Usato
    
    // caso --> a mio nome
    cuAttuale: number | undefined
    anzianitaPrimaClasse: number | undefined
    compagniaAttuale: number | undefined
    etaAssicurativa: number | undefined
    numeroIncidenti: number | undefined
    incidenti: AccidentListType // // incidenti
    haEreditatoCu: boolean | undefined
    // caso <-- a mio nome

    // contraente e proprietario coincidono?
    isSameContractorOwner: number | undefined
    owner: FisicaType | undefined,

    // altri conducenti
    altriConducenti: boolean | undefined
    etaConducentePiuGiovane: number | undefined

    statoAssicurativoError: string | undefined

    tipoEreditaCuError: string | undefined
    cuEreditataError: string | undefined
    tipoVeicoloEreditaCuError: string | undefined
    targaCuError: string | undefined

    cuAttualeError: string | undefined
    anzianitaPrimaClasseError: string | undefined
    compagniaAttualeError: string | undefined
    etaAssicurativaError: string | undefined
    haEreditatoCuError: string | undefined
    numeroIncidentiError: string | undefined
    incidentiError: AccidentErrorList

    isSameContractorOwnerError: string | undefined
    ownerError: string | undefined

    altriConducentiError: string | undefined
    etaConducentePiuGiovaneError: string | undefined

    tipiStatoAssicurativo: any
    tipiFruizioneEredita: any
    tipiCuEreditata: any
    tipiVeicoloEretiaCu: any

    tipiCuAttuale: any
    tipiAnzianitaPrimaClasse: any
    tipiCompagnieAttuali: any
    tipiEtaAssicurativa: any

    tipiAnniIncidenti: any
    tipiResponsabilitaIncidenti: any

    tipiRelazioniPersone: any
}

export const baseInsuranceDataInitialStatus = {
    statoAssicurativo: undefined,
    tipoEreditaCu: undefined,
    tipoVeicoloEreditaCu: undefined,
    targaCu: undefined,
    cuEreditata: undefined,
    cuAttuale: undefined,
    anzianitaPrimaClasse: undefined,
    compagniaAttuale: undefined,
    etaAssicurativa: undefined,
    haEreditatoCu: undefined,
    numeroIncidenti: undefined,
    incidenti: [],

    isSameContractorOwner: undefined,
    owner: undefined,

    altriConducenti: undefined,
    etaConducentePiuGiovane: undefined,

    statoAssicurativoError: undefined,
    tipoEreditaCuError: undefined,
    tipoVeicoloEreditaCuError: undefined,
    targaCuError: undefined,
    cuEreditataError: undefined,
    cuAttualeError: undefined,
    anzianitaPrimaClasseError: undefined,
    compagniaAttualeError: undefined,
    etaAssicurativaError: undefined,
    haEreditatoCuError: undefined,
    numeroIncidentiError: undefined,
    incidentiError: [],

    isSameContractorOwnerError: undefined,
    ownerError: undefined,

    altriConducentiError: undefined,
    etaConducentePiuGiovaneError: undefined,

    tipiStatoAssicurativo: undefined,
    tipiFruizioneEredita: undefined,
    tipiVeicoloEretiaCu: undefined,
    tipiCuEreditata: undefined,
    tipiCuAttuale: undefined,
    tipiAnzianitaPrimaClasse: undefined,
    tipiCompagnieAttuali: undefined,
    tipiEtaAssicurativa: undefined,

    tipiAnniIncidenti: undefined,
    tipiResponsabilitaIncidenti: undefined,

    tipiRelazioniPersone: undefined,
}

// props per il component "stato assicurativo" generico
export interface InsuranceDatarops extends InsuranceDataStatus {
    dataScadenza: string | undefined, 
    dataScadenzaError: string | undefined,

    showOwner: boolean
    contractor: ContractorType

    etaMinimaConducente: number

    updateStatoAssicurativoCallBack: Function

    updateTipoEreditaCuCallBack: Function
    updateTipoVeicoloEreditaCuCallBack: Function
    updateTargaCuCallBack: Function
    updateCuEreditataCallBack: Function

    updateCuAttualeCallBack: Function
    updateAnzianitaPrimaClasseCallBack: Function
    updateCompagniaAttualeIdCallBack: Function
    updateEtaAssicurativaCallBack: Function
    updateHaEreditatoCuCallBack: Function
    updateNumeroIncidentiCallBack: Function
    updateIncidentiCallBack: Function

    updateIsSameContractorOwnerCallBack: Function
    updateOwnerCallBack: Function

    updateAltriConducentiCallBack: Function,
    updateEtaConducentePiuGiovaneCallBack: Function,

    updateUserCallBack: Function

    updateDataScadenza: Function

    user: UserType | undefined
    manageExpiredSessionsCallBack: Function
}

// props per lo stato della polizza
export interface InsurancePolicyProps {
    siNoValue: SiNoType,    // polizza attiva?
    siNoId: string,
    siNoLabel: string,

    siNoCallBack: Function

    dataValue: string | undefined,  // data scadenza eventuale polizza?
    dataId: string,
    dataLabel: string,

    dataCallBack: Function
    
    errorAttiva?: string
    errorScadenza?: string
}

export const ACCIDENT_NUMER = [
    {id: "0", value: "0"},
    {id: "1", value: "1"},
    {id: "2", value: "2"},
    {id: "3", value: "3"},
    {id: "4", value: "4"},
    {id: "5", value: "5"},
    {id: "6", value: "6"},
    {id: "7", value: "7"},
    {id: "8", value: "8"},
    {id: "9", value: "9"},
    {id: "10", value: "10"},
    {id: "11", value: "11"},
    {id: "12", value: "12"},
    {id: "13", value: "13"},
    {id: "14", value: "14"},
    {id: "15", value: "15"},
]

export const MICROCAR_MIN_CONDUCENTE_AGE = 14
